class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.activeElement = null;

    if (!this.notification) return;

    this.notification.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });

    this.querySelectorAll('button[type="button"]').forEach((button) => {
      button.addEventListener('click', this.close.bind(this));
    });
  }

  open() {
    if (!this.notification) return;

    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        if (typeof trapFocus === 'function') {
          trapFocus(this.notification);
        }
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);

    setTimeout(() => {
      this.setupVerification();
    }, 100);
  }

  close() {
    if (!this.notification) return;

    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id);
      if (!elementToReplace) return;

      const sectionHTML = parsedState.sections[section.id];
      if (!sectionHTML) return;

      elementToReplace.innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
    });

    if (this.header && typeof this.header.reveal === 'function') {
      this.header.reveal();
    }

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
        selector: '#cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
        selector: '#cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const element = parsedHTML.querySelector(selector);
    return element ? element.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  setupVerification() {
    const checkbox = this.notification.querySelector('#cartVerificationCheck');
    const checkoutBtn = this.notification.querySelector('#cart-notification-checkout');
    const errorMsg = this.notification.querySelector('#cart-verification-error');

    if (!checkbox || !checkoutBtn || !errorMsg) return;

    checkbox.checked = false;
    checkoutBtn.disabled = true;
    checkoutBtn.setAttribute('disabled', 'disabled');
    checkoutBtn.setAttribute('aria-disabled', 'true');
    checkoutBtn.classList.add('cart-checkout-disabled');
    errorMsg.style.display = 'none';

    checkbox.onchange = () => {
      if (checkbox.checked) {
        checkoutBtn.disabled = false;
        checkoutBtn.removeAttribute('disabled');
        checkoutBtn.setAttribute('aria-disabled', 'false');
        checkoutBtn.classList.remove('cart-checkout-disabled');
        errorMsg.style.display = 'none';
      } else {
        checkoutBtn.disabled = true;
        checkoutBtn.setAttribute('disabled', 'disabled');
        checkoutBtn.setAttribute('aria-disabled', 'true');
        checkoutBtn.classList.add('cart-checkout-disabled');
        errorMsg.style.display = 'none';
      }
    };

    checkoutBtn.onclick = (e) => {
      if (!checkbox.checked) {
        e.preventDefault();
        e.stopPropagation();
        errorMsg.style.display = 'block';
      }
    };
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}